module.exports = __webpack_public_path__ + "assets/19c249342a15d7890dd78405db42971e.png";